<template>
  <div>
    <div v-if="loading">
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <div v-else>
      <pair title="ID" :value="swapId" />

      <b-row>
        <b-col>
          <b-card> <LegDetails :leg="payLeg" /> </b-card> </b-col
        ><b-col>
          <b-card> <LegDetails :leg="recLeg" /> </b-card></b-col
      ></b-row>
    </div>
  </div>
</template>

<script>
import LegDetails from "@/components/LegDetails.vue";

export default {
  props: {
    swapId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      payLeg: null,
      recLeg: null,
      loading: true
    };
  },
  async mounted() {
    let trade = await this.$client.getTradeById(this.swapId);
    this.payLeg = trade.legs.filter(leg => leg.payReceive == "Pay")[0];
    this.recLeg = trade.legs.filter(leg => leg.payReceive == "Receive")[0];
    this.loading = false;
    // emit stuff
    this.$emit("ready", this.payLeg, this.recLeg);
  },
  methods: {
    legType(leg) {
      if (leg.calculation.index !== undefined) {
        return "Floating";
      } else {
        return "Fixed";
      }
    }
  },
  components: { LegDetails }
};
</script>
